export enum ConsultantLocatorErrorType {
  None = 'None',
  ZipCodeNotFound = '404',
}
